export default "__VITE_ASSET__de273c38__"